import axios from 'axios';
import cookie from '../cookieHelper/cookie'; // Assuming you have a cookie helper

export default function getReelInsights(storyId, type) {
    let API_URL;

    // Construct API URL
    if (typeof storyId === 'undefined') {
        API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/reelInsights?type=${type}`;
    } else {
        API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/reelInsights?storyId=${storyId}`;
    }

    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    return axios
        .get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            // console.log('res.data: ', res.data);
            return res.data;
        })
        .catch(err => {
            // console.error('Error fetching reel insights: ', err);
            return err;
        });
}
